import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { filter, first, map, switchMap } from 'rxjs/operators';

import { LastChangeMixin } from '../../@core/api/models';
import { UsersService } from '../../@core/utils';
import { UsernamePipe } from './username.pipe';

@Pipe({
    name: 'ngxLastChange',
    pure: false,
    standalone: true,
})
export class LastChangePipe implements PipeTransform {
  private cachedResult: string = '';
  private cachedLastChangeBy: number;
  private cachedLastChangeOn;

  constructor(
    private datePipe: DatePipe,
    private translate: TranslateService,
    private usersService: UsersService,
    private usernamePipe: UsernamePipe,
  ) { }

  transform<T extends LastChangeMixin>(object: T, translationKey: string): string {
    if (object && object.last_change_by && object.last_change_on) {
      if (this.cachedLastChangeBy !== object.last_change_by && this.cachedLastChangeOn !== object.last_change_on) {
        this.cachedResult = '';
        this.cachedLastChangeBy = object.last_change_by;
        this.cachedLastChangeOn = object.last_change_on;

        this.usersService.allUsers$.pipe(
          filter((users) => users.length > 0),
          first(),
          map((users) => {
            const lastChangeBy = users.find((user) => user.get_user_id === object.last_change_by);
            const lastChangeDate = new Date(object.last_change_on);
            return {
              user: this.usernamePipe.transform(lastChangeBy),
              date: this.datePipe.transform(lastChangeDate, 'mediumDate'),
            };
          }),
          switchMap((lastChangeParams) => this.translate.get(translationKey, lastChangeParams)),
        ).subscribe((result) => {
          this.cachedResult = result;
        });
      }

      return this.cachedResult;
    }
  }
}
